export const LOGIN = '/user/login';
export const SIGNUP = '/user/signup';
export const CONFIRM_SIGNUP = '/user/confirm-signup';
export const CONFIRM_PROMOCODE = '/user/verify-promocode';
export const IMPORT_FILE = '/file/import-file';
export const FORGOT_PASSOWRD = '/user/forgot-password';
export const FORGOT_PASSOWRD_CONFIMR = '/user/confirm-forgot-password';
export const RESEND_CONFIRMATION_CODE = '/user/resend-code';
export const CHANGE_PASSWORD = '/user/change-password';
export const GET_FILE_UPLOAD_DETAILS = '/file/get-file-upload-details';
export const GET_COLUMN_DEFINITIONS = '/file/get-column-definitions';
export const GET_DATASET_DETAILS = '/file/get-dataset-details';
export const GET_DATABASE_TYPE = '/database-type/get-database-type';
export const ADD_DATABASE_DETAIL = '/database/add-database-detail';
export const GET_DATABASE_DETAIL = '/database/get-database-detail';
export const INSERT_USER_AGREEMENT = '/user-agreement/insert-user-agreement';
export const GET_USER_AGREEMENT = '/user-agreement/get-user-agreed';
export const GET_TEMPLATE_BY_USERID = '/template/get-by-userId';
export const ADD_TEMPLATE = '/template/insert-template';
export const GENERATE_TOKEN = '/user/generate-token';
export const CONTACT_US_EMAIL = '/email/contact-us-email';

